import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { apiPost } from '../lib/api';

export function ResetPasswordPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [pwd, setPwd] = useState('');
  const [pwd2, setPwd2] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    if (pwd.length < 8) {
      setErr('8 caractères minimum');
      return;
    }
    if (!/^[A-Za-z0-9@.-]+$/.test(pwd)) {
      setErr('Lettres sans accent, chiffres et @ . - uniquement (compatibilité avec Jarvis V1)');
      return;
    }
    if (pwd !== pwd2) {
      setErr('Les deux mots de passe ne correspondent pas');
      return;
    }
    if (!token || !/^[a-f0-9]{64}$/.test(token)) {
      setErr('Lien invalide');
      return;
    }
    setSubmitting(true);
    try {
      await apiPost('/api/auth/reset', { token, new_password: pwd });
      setDone(true);
      setTimeout(() => navigate('/login', { replace: true }), 2000);
    } catch (e2) {
      setErr(e2 instanceof Error ? e2.message : 'Erreur');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-soft)',
      }}
    >
      <div style={{ width: 360, padding: 32, background: 'var(--bg)', borderRadius: 10, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        <div style={{ textAlign: 'center', marginBottom: 18 }}>
          <img src="/dt-logo.png" alt="Digital Team" className="brand-logo" style={{ height: 50 }} />
          <h1 style={{ fontSize: 'var(--fs-md)', fontWeight: 600, marginTop: 12 }}>Nouveau mot de passe</h1>
        </div>

        {done ? (
          <div
            style={{
              padding: 12,
              background: 'var(--success-soft)',
              color: 'var(--success-text)',
              borderRadius: 6,
              fontSize: 'var(--fs-sm)',
              textAlign: 'center',
            }}
          >
            ✓ Mot de passe modifié. Redirection vers la connexion…
          </div>
        ) : (
          <form onSubmit={onSubmit} style={{ display: 'grid', gap: 12 }}>
            <label style={{ display: 'grid', gap: 4 }}>
              <span style={{ fontSize: 'var(--fs-xs)', color: 'var(--text-mute)' }}>Nouveau mot de passe</span>
              <input
                type="password"
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                required
                minLength={8}
                autoFocus
                style={inputStyle}
              />
            </label>
            <label style={{ display: 'grid', gap: 4 }}>
              <span style={{ fontSize: 'var(--fs-xs)', color: 'var(--text-mute)' }}>Confirmer</span>
              <input
                type="password"
                value={pwd2}
                onChange={(e) => setPwd2(e.target.value)}
                required
                minLength={8}
                style={inputStyle}
              />
            </label>
            {err && (
              <div style={{ fontSize: 'var(--fs-sm)', color: 'var(--danger)', background: 'var(--danger-soft)', padding: 10, borderRadius: 6 }}>
                {err}
              </div>
            )}
            <button type="submit" disabled={submitting} className="btn primary" style={{ marginTop: 4 }}>
              {submitting ? '…' : 'Définir le mot de passe'}
            </button>
            <div style={{ textAlign: 'center', marginTop: 4 }}>
              <Link to="/login" style={{ fontSize: 'var(--fs-xs)' }}>
                Retour à la connexion
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

const inputStyle: React.CSSProperties = {
  padding: '10px 12px',
  border: '1px solid var(--border)',
  borderRadius: 6,
  fontSize: 'var(--fs-base)',
};
